import { create } from 'zustand';

interface StoreState {
  cheatsheetView: 'grid' | 'list';
  cheatsheetOrder: 'level' | 'flat';
  cheatsheetFilter: 'all' | 'bookmarks' | 'reviews';
  cheatsheetEditable: boolean;
}

const useTabStore = create<StoreState>(() => ({
  cheatsheetView: 'grid',
  cheatsheetOrder: 'level',
  cheatsheetFilter: 'bookmarks',
  cheatsheetEditable: false,
}));

export const setCheatsheetView = (view: 'grid' | 'list') =>
  useTabStore.setState((state) => ({ ...state, cheatsheetView: view }));

export const setCheatsheetOrder = (order: 'level' | 'flat') =>
  useTabStore.setState((state) => ({ ...state, cheatsheetOrder: order }));

export const setCheatsheetFilter = (filter: 'all' | 'bookmarks' | 'reviews') =>
  useTabStore.setState((state) => ({ ...state, cheatsheetFilter: filter }));

export const setCheatsheetEditable = (editable: boolean) =>
  useTabStore.setState((state) => ({ ...state, cheatsheetEditable: editable }));

export default useTabStore;
